import { endOfDay, startOfDay, startOfMonth, startOfYear, subDays, subYears } from "date-fns";
import { today } from 'AppReact';

export default {
  'DatePickerButtons.Today': ({ }, outlet) => {
    outlet({ startDate: startOfDay(today()), endDate: endOfDay(today()), selectedYear: today().getFullYear(), selectedTimeSpan: 'today' })
  },
  'DatePickerButtons.LastWeek': ({ }, outlet) => {
    outlet({ startDate: startOfDay(subDays(today(), 6)), endDate: endOfDay(today()), selectedYear: today().getFullYear(), selectedTimeSpan: 'lastWeek' })
  },
  'DatePickerButtons.LastMonth': ({ }, outlet) => {
    outlet({ startDate: startOfDay(subDays(today(), 29)), endDate: endOfDay(today()), selectedYear: today().getFullYear(), selectedTimeSpan: 'lastMonth' })
  },
  'DatePickerButtons.LastYear': ({ }, outlet) => {
    outlet({ startDate: startOfDay(subYears(today(), 1)), endDate: endOfDay(today()), selectedYear: today().getFullYear(), selectedTimeSpan: 'lastYear' })
  },
  'DatePickerButtons.AllTime': ({ }, outlet) => {
    outlet({ startDate: window?.first_work_order_date ? new Date(window.first_work_order_date) : startOfDay(subYears(today(), 10)), endDate: endOfDay(today()), selectedTimeSpan: 'allTime' })
  },
  'DatePickerButtons.Custom': ({ start, end }, outlet) => {
    outlet({ selectedTimeSpan: 'custom', startDate: start, endDate: end })
  },
  'DatePickerButtons.YTD': ({ }, outlet) => {
    outlet({ startDate: startOfDay(startOfYear(today())), endDate: endOfDay(today()), selectedYear: today().getFullYear(), selectedTimeSpan: 'ytd' })
  },
  'DatePickerButtons.MTD': ({ }, outlet) => {
    outlet({ startDate: startOfDay(startOfMonth(today())), endDate: endOfDay(today()), selectedYear: today().getFullYear(), selectedTimeSpan: 'mtd' })
  },
}